module.exports = __webpack_public_path__ + "static/media/Novara.7e7c0510.png";